//过滤脏数据
import store from "@/store"
function generateRandomNumber(length){
    let result = '';
    // 循环 length 次
    for (let i = 0; i < length; i++) {
      // Math.random() 生成 0-1 之间的小数
      // * 10 得到 0-9 之间的小数
      // Math.floor 向下取整得到 0-9 的整数
      result += Math.floor(Math.random() * 10);
    }
    return result;
}
export function rtext(value,bit) {//数据脱敏 type 类型  bit 位数
    const isLogin = store.getters.isLogin
    if(isLogin){
        if(value){
            return value
        }else{
            return '--'
        }
    }else {
        return generateRandomNumber(bit)
    }
    
    
}